// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_go-0";
export var fulfillmentPanelBody = "_go-1";